// Script para migrar movimientos existentes y marcarlos como automáticos o manuales
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from './firebaseConfig';

export async function migrateMovimientosAutomatic() {
  try {
    console.log('Iniciando migración de movimientos...');
    
    const movimientosRef = collection(db, 'movimientos');
    const snapshot = await getDocs(movimientosRef);
    
    let automaticCount = 0;
    let manualCount = 0;
    let updatedCount = 0;
    
    for (const docSnapshot of snapshot.docs) {
      const movimiento = docSnapshot.data();
      const docId = docSnapshot.id;
      
      // Determinar si es automático basado en características existentes
      let isAutomatic = false;
      
      // Movimientos automáticos: tienen origen 'lote' o referencia con 'Cuota:'
      if (movimiento.origen === 'lote' || 
          (movimiento.referencia && movimiento.referencia.includes('Cuota:'))) {
        isAutomatic = true;
      }
      
      // Solo actualizar si no tiene el campo automatic definido
      if (movimiento.automatic === undefined) {
        await updateDoc(doc(db, 'movimientos', docId), {
          automatic: isAutomatic
        });
        updatedCount++;
        
        if (isAutomatic) {
          automaticCount++;
        } else {
          manualCount++;
        }
        
        console.log(`Movimiento ${docId}: marcado como ${isAutomatic ? 'automático' : 'manual'}`);
      } else {
        // Ya tiene el campo, solo contar
        if (movimiento.automatic) {
          automaticCount++;
        } else {
          manualCount++;
        }
      }
    }
    
    console.log(`Migración completada:`);
    console.log(`- Movimientos actualizados: ${updatedCount}`);
    console.log(`- Movimientos automáticos: ${automaticCount}`);
    console.log(`- Movimientos manuales: ${manualCount}`);
    console.log(`- Total de movimientos: ${snapshot.size}`);
    
  } catch (error) {
    console.error('Error en migración de movimientos:', error);
    throw error;
  }
}

// Función para ejecutar la migración desde la consola del navegador
(window as any).migrateMovimientosAutomatic = migrateMovimientosAutomatic; 